<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12" md="8">
                <v-card flat>
                    <v-card-text>
                        <v-form>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                            outlined
                                            label="Name"
                                            v-model="$v.editedItem.name.$model"
                                            :error-messages="nameError"
                                            error-count=2
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <autocomplete title="name"
                                                  label="Select Employee Categories"
                                                  :items="entityGroupTypes"
                                                  :selected-items="entityGroupTypesSelected"
                                                  :sub-title="['subtitle']"
                                                  @autocomplete-selected="updateSelectedItemsGroupType($event)"
                                                  :error-messages="typeError"
                                                  error-count=1
                                    >
                                    </autocomplete>
                                </v-col>
                                <v-col cols="10" md="11">
                                    <autocomplete title="name"
                                                  label="Select Document Rule"
                                                  :items="documentRules"
                                                  :sub-title="['subtitle']"
                                                  :multipleItems="false"
                                                  :selected-items="documentRulesSelected"
                                                  @autocomplete-selected="updateSelectedItems($event)"
                                                  :error-messages="docError"
                                                  error-count=1
                                    >
                                    </autocomplete>
                                </v-col>
                                <v-col cols="2" md="1" class="my-3">
                                    <v-btn dark
                                           icon
                                           large
                                           @click="goToDocRule"
                                           color="blue"
                                           >
                                        <v-icon large>
                                            mdi-plus-circle-outline
                                        </v-icon>
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col cols="6" sm="2">
                                    <v-btn color="default" text @click="close">Cancel</v-btn>
                                </v-col>
                                <v-col cols="6" sm="2">
                                    <v-btn color="primary"
                                           :loading="isSaving"
                                           :disabled="isSaving"
                                           @click="save">Save</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <dialog-alert :text="alertText"
                      :alert-type="alertType"
                      :open="openAlert"
                      @alert-closed="alertClosed($event)">
        </dialog-alert>
    </v-container>
</template>

<script>
    import alertEventBus from '@/eventBus/AlertEventBus';
    import {required, minLength} from 'vuelidate/lib/validators';
    import {AuthorizationRule} from '../../../../shared/dtos/Dtos';
    import { FORM_STATUS } from '../../../../shared/enums/FormStatuses';
    const DialogAlert = () => import ('@/components/common/DialogAlert');
    import {formUnsavedMixin} from "../../../../shared/mixins/FormUnsaved";
    import { ALPHA_WITH_SPACES_VALIDATOR } from "../../../../shared/validators/Validators";
    import {DOCUMENT_RULE_CONFIGURATIONS} from '@/shared/enums/DocumentRule';
    const Autocomplete = ()=> import("@/components/common/Autocomplete");
    import {DOCUMENT_RULE_TYPES} from '@/shared/enums/DocumentRule';

    export default {
        name: "authorizationRuleForm",
        props:['id'],
        components:{
            DialogAlert, Autocomplete
        },
        mixins:[formUnsavedMixin],
        data() {
            return {
                isSaving: false,
                editedItem: {...AuthorizationRule},
                documentRules: [],
                documentRulesSelected:[],
                entityGroupTypes: [],
                entityGroupTypesSelected: [],
            };
        },
        validations: {
            editedItem:{
                name: {
                    required,
                    minLength: minLength(2),
                    ALPHA_WITH_SPACES_VALIDATOR
                },
            },
            entityGroupTypesSelected:{
                required
            },
            documentRulesSelected:{
                required
            }
        },
        computed:{
            nameError(){
                const errors = []
                if (!this.$v.editedItem.name.$dirty) {
                    return errors
                }

                !this.$v.editedItem.name.minLength && errors.push('Name must be at least '+
                    this.$v.editedItem.name.$params.minLength.min +' characters long')
                !this.$v.editedItem.name.required && errors.push('Name is required.')
                !this.$v.editedItem.name.ALPHA_WITH_SPACES_VALIDATOR && errors.push('Name must contains only letters')
                return errors
            },
            typeError(){
                const errors = []
                if (!this.$v.entityGroupTypesSelected.$dirty) {
                    return errors
                }

                !this.$v.entityGroupTypesSelected.required && errors.push('Category is required.')
                return errors
            },
            docError(){
                const errors = []
                if (!this.$v.documentRulesSelected.$dirty) {
                    return errors
                }

                !this.$v.documentRulesSelected.required && errors.push(DOCUMENT_RULE_CONFIGURATIONS.REQUIRED.REQUIRED);
                return errors
            }
         },
        methods:{
            async initialize()
            {
                //add exclude paths
                this.excludePath.push('authorization');
                this.getDocumentRules();
                this.getEntityGroupTypes();

                if(this.id)
                    await this.$store.dispatch('getAuthorizationRule',{id: this.id});

                if(this.$store.getters.getAuthorizationRule.name) {
                    this.editedItem = this.$store.getters.getAuthorizationRule;
                    if(this.$route.fullPath.includes("clone")){
                      delete this.editedItem.name;
                      delete this.editedItem.id;
                    }

                    this.documentRulesSelected = { id: this.editedItem.documentRuleId,
                        name: this.editedItem.documentRuleName};
                    this.entityGroupTypesSelected = this.editedItem.employeeGroupTypes;
                }
            },
            close(){
                this.resetValues();
                this.status = FORM_STATUS.CLOSE;
                this.$router.push({name: 'clientAuthorizationTable'});
            },
            resetValues(){
                this.$v.$reset();
                this.$store.commit('setAuthorizationRule', {});
            },
            async save(){
                this.$v.$touch();
                if(this.$v.$anyError)
                    return;

                this.isSaving = true;
                //not updates allow it
                delete this.editedItem.id;

                try {
                    await this.$store.dispatch('setAuthorizationRule',this.editedItem);
                    /**
                     * Updating list of AuthorizationRules
                     */
                    this.$store.commit('setAuthorizationRules', []);
                }
                catch (e) {
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    this.isSaving = false;
                    return ;
                }

                this.status = FORM_STATUS.SAVE;
                this.close();
            },
            goToDocRule(){
                this.$store.commit('setAuthorizationRule', this.editedItem);
                this.$router.push({name: 'documentRuleAdd',params:{path_type:"authorization"},query:{redirect:'clientAuthorizationAdd'}})
            },
            async getDocumentRules(){
                //going backend
                try{
                    await this.$store.dispatch('getDocumentRules', {type : DOCUMENT_RULE_TYPES.AUTHORIZATION});
                    this.documentRules = this.$store.getters.getDocumentRules;
                }
                catch (e) {
                    //set alert
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    return;
                }

                this.documentRules = this.documentRules.map((item) => {
                    let subTitleRequired = item.required ? DOCUMENT_RULE_CONFIGURATIONS.REQUIRED.REQUIRED : DOCUMENT_RULE_CONFIGURATIONS.REQUIRED.NO_REQUIRED;
                    let subTitleExpiration;
                    if(item.expiredInterval !== DOCUMENT_RULE_CONFIGURATIONS.EXPIRATION.DEFAULT_VALUE){
                        let interval = item.expiredInterval.split('-');
                        subTitleExpiration = `Expires in ${interval[0]} ${interval[1]}`;
                    }
                    else{
                        subTitleExpiration = DOCUMENT_RULE_CONFIGURATIONS.EXPIRATION.NO_EXPIRE_TEXT;
                    }

                    item.subtitle = `${subTitleRequired} | ${subTitleExpiration}`;

                    return item;
                });
            },
            updateSelectedItems(data){
                this.$v.documentRulesSelected.$touch();
                this.editedItem.documentRuleId = data.id;
                this.editedItem.documentRuleName = data.name;
                this.documentRulesSelected = data;
            },
            async getEntityGroupTypes(){
                this.entityGroupTypes = this.$store.getters.getEmployeeTypes;
                if(this.entityGroupTypes.length <= 0){
                    //going backend
                    try{
                        await this.$store.dispatch('getEmployeeTypes');
                        this.entityGroupTypes = this.$store.getters.getEmployeeTypes;
                    }
                    catch (e) {
                        //set alert
                        alertEventBus.setAlert({type:'error', msg: e.message});
                        return;
                    }
                }

                this.entityGroupTypes = this.entityGroupTypes.map((item) => {
                    let docGroups = item.documentGroups;
                    item.subtitle = null;
                    for(let key in docGroups){
                        let line = item.subtitle === null? '': item.subtitle + ' | ';
                        item.subtitle = line +  docGroups[key].name;
                    }
                    return item;
                });

            },
            updateSelectedItemsGroupType(data) {
                this.$v.entityGroupTypesSelected.$touch();
                this.editedItem.employeeGroupTypes = data.map(doc => {
                    let object = {
                        id: doc.id,
                        name: doc.name
                    };

                    return object
                });
                this.entityGroupTypesSelected = data;
            }
        },
        async created(){
            this.initialize();
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }
</style>